/** ROS 2 type for `/gimbal/control_speed` — passed to arcjs so ROSLibJS skips per-send `getTopicType`. */
export const GIMBAL_CONTROL_SPEED_MSG_TYPE = "geometry_msgs/msg/Twist";
export const GIMBAL_ZOOM_MSG_TYPE = "std_msgs/msg/Int32";
export const GIMBAL_ABSOLUTE_ZOOM_MSG_TYPE = "std_msgs/msg/Float32";
export const GIMBAL_FOCUS_MSG_TYPE = "std_msgs/msg/Int32";
export const GIMBAL_TOUCH_FOCUS_MSG_TYPE = "geometry_msgs/msg/Point";

// Gimbal control speed (continuous rotation)
export const setGimbalSpeed = ({ yaw = 0, pitch = 0 }) => [
    "/gimbal/control_speed",
    {
        linear: { x: 0, y: 0, z: 0 },
        angular: { x: 0, y: pitch, z: yaw },
    },
    GIMBAL_CONTROL_SPEED_MSG_TYPE,
];

// Gimbal angle control (absolute positioning)
export const setGimbalAngle = ({ yaw = 0, pitch = 0 }) => [
    "/gimbal/angle_control",
    {
        linear: { x: 0, y: 0, z: 0 },
        angular: { x: 0, y: pitch, z: yaw },
    },
];

// Gimbal zoom control (1: zoom in, 0: stop, -1: zoom out)
export const setGimbalZoom = (value) => ["/gimbal/zoom", value, GIMBAL_ZOOM_MSG_TYPE];

// Gimbal absolute zoom (1.0 to 30.9)
export const setGimbalAbsoluteZoom = (zoomMultiple) => [
    "/gimbal/absolute_zoom",
    zoomMultiple,
    GIMBAL_ABSOLUTE_ZOOM_MSG_TYPE,
];

// Gimbal manual focus (1: long shot, 0: stop, -1: close shot)
export const setGimbalFocus = (value) => ["/gimbal/manual_focus", value, GIMBAL_FOCUS_MSG_TYPE];

// Gimbal touch-to-focus (x, y coordinates)
export const setGimbalTouchFocus = ({ x, y }) => [
    "/gimbal/touch_focus",
    { x, y, z: 0 },
    GIMBAL_TOUCH_FOCUS_MSG_TYPE,
];

// Gimbal services
export const gimbalCenter = () => ["/gimbal/center", {}];
export const gimbalAutoFocus = () => ["/gimbal/auto_focus", {}];
export const gimbalCaptureImage = () => ["/gimbal/capture_image", {}];
export const gimbalGetStatus = () => ["/gimbal/get_status", {}];
